module.exports = __webpack_public_path__ + "img/section3-shadow-top.1a9e8269.png";